import {
  OutputNodeDefinition,
  Provider,
  TableSchema,
  WorkflowComponentCheckInputValuesParams,
  WorkflowComponentCodeParams,
  WorkflowComponentParameterMode,
  WorkflowComponentParamType,
  WorkflowComponentValue,
  WorkflowParameterValueErrorType
} from '../types'
import { SelectSameSchemaWorkflowComponent } from './common/selectsameschemacomponent'

class Union extends SelectSameSchemaWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.unionall',
        group: 'Joins',
        title: 'Union All',
        description: `
        This component generates a new table that is the union of several input ones.
      `,
        starred: true
      },
      [
        {
          name: 'tables',
          type: WorkflowComponentParamType.InputTable,
          title: 'Tables',
          mode: WorkflowComponentParameterMode.Multiple
        }
      ]
    )
  }

  checkInputValues({
    params,
    resolvedParamValues,
    connection,
    dryRun,
    schemas,
    variables
  }: WorkflowComponentCheckInputValuesParams) {
    const problems = super.checkInputValues({
      params,
      resolvedParamValues,
      connection,
      dryRun,
      schemas,
      variables
    })
    if (schemas) {
      const unionSchemas: Array<TableSchema> = []
      const tables = params.tables as WorkflowComponentValue[]
      for (const table of tables) {
        const componentOutputs = schemas.find(
          (x) => (table.value as OutputNodeDefinition).component === x.componentName
        )
        if (componentOutputs) {
          const outputSchema = componentOutputs.schemas.find(
            (x) => x.name === (table.value as OutputNodeDefinition).output
          )
          if (outputSchema && outputSchema.schema) {
            unionSchemas.push(outputSchema.schema)
          }
        }
      }
      const areEqual = unionSchemas.every((schema) =>
        unionSchemas[0].every((col) => schema.find((colb) => colb.name === col.name && colb.type === col.type))
      )

      if (!areEqual) {
        problems.push({
          parameter: 'tables',
          type: WorkflowParameterValueErrorType.WrongValue,
          message: 'Schemas of all input tables must be equal'
        })
      }
    }
    return problems
  }

  getInnerSql({ params, connection, schemas }: WorkflowComponentCodeParams) {
    let columns = '*'
    if (schemas?.input.tables && schemas.input.tables.length > 0) {
      columns = (schemas.input.tables as Array<TableSchema>)[0].map((x) => x.name).join(', ')
    }
    const queries =
      connection.type === Provider.DatabricksRest
        ? (params.tables as Array<string>).map(
            (x) => `SELECT /*+ REPARTITION(40) */ ${columns} FROM ${connection.quoteName(x)}`
          )
        : (params.tables as Array<string>).map((x) => `SELECT ${columns} FROM ${connection.quoteName(x)}`)
    return queries.join('\nUNION ALL\n')
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { Union }
